// Modal.js (TheBasket)
import { useContext, useEffect } from 'react';
import React from 'react';
import "./TheBasket.css";
import BasketItem from "./BasketItem";
import { BasketContext } from '../../BasketContext'; // Don't import BasketProvider here
import { Link } from 'react-router-dom';

const TheBasket = ({ isOpen, onClose }) => {
  // 1. Single source of truth: pull directly from Context
  const { basket, setBasket } = useContext(BasketContext);
  let currBasket = []

  let basketUpdated = false

  const updateQuantity = (itemID, delta) => {
    const updatedBasket = currBasket.map((item) => {
      if (item.ItemID === itemID) {
        // Ensure quantity doesn't go below 1
        const newQty = Math.max(1, item.Quantity + delta);
        return { ...item, Quantity: newQty };
      }
      return item;
    });
    setBasket(updatedBasket);
    currBasket = JSON.parse(JSON.stringify(updatedBasket))
    localStorage.setItem('LocalBasket', JSON.stringify(updatedBasket));
    basketUpdated = true
  };

  const deleteItemFromBasket = (itemID) => {
    const updatedBasket = currBasket.filter((item) => item.ItemID !== itemID);
    setBasket(updatedBasket);
    currBasket = JSON.parse(JSON.stringify(updatedBasket))
    localStorage.setItem('LocalBasket', JSON.stringify(updatedBasket));
    basketUpdated = true
  };

  // useEffect(() => {
  //   console.log("TheBasket currBasket changed:", currBasket);
  // }, [currBasket]);

  if (!isOpen) return null;

  //Derive total directly from basket state (no useEffect needed)
  let basketTotal = currBasket.reduce((acc, item) => acc + item.BasePrice * item.Quantity, 0);

  if (!basketUpdated && (!currBasket || currBasket.length === 0)) {
    currBasket = JSON.parse(localStorage.getItem("LocalBasket")) || [];
    basketTotal = currBasket.reduce((acc, item) => acc + item.BasePrice * item.Quantity, 0);
    //setBasket(currBasket)
    basketUpdated = true
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 id="basket-title">Your Basket</h2>
          <button className="close-button" onClick={onClose}>✕</button>
        </div>

        <div className="total-cost">
          <p> Basket Total: R{basketTotal.toFixed(2)}</p>
        </div>

        {(!currBasket || currBasket.length === 0) ? (
          <div className="empty-cart">
            <div className="empty-icon">🛒</div>
            <div className="empty-text">Your cart is empty</div>
            <Link to="/" className="continue-btn" onClick={onClose}>Continue Shopping</Link>
          </div>
        ) : (
          currBasket.map((item) => (
            /* REMOVED: Nested <BasketProvider> wrapping individual items */
            <BasketItem
              key={item.ItemID}
              basket={currBasket}
              thisItem={item}
              updateQuantity={updateQuantity}
              deleteItemFromBasket={deleteItemFromBasket}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default TheBasket;